/*
  Kalessie - WhatsApp bubble. Appears after a short delay; on a product page it
  pre-fills the message with the product name. Number/message come from data
  attributes set by snippets/kalessie-whatsapp.liquid.
*/
(function () {
  function init() {
    var btn = document.querySelector('.kal-whatsapp');
    if (!btn) return;
    var base = btn.getAttribute('data-base');
    var msg = btn.getAttribute('data-message') || '';
    var titleEl = document.querySelector('.product__title h1') || document.querySelector('.product__title');
    var title = titleEl ? titleEl.textContent.trim() : '';
    var text = msg + (title ? ' about ' + title : '') + '.';
    btn.setAttribute('href', base + '?text=' + encodeURIComponent(text));
    setTimeout(function () { btn.classList.add('is-visible'); }, 2500);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
